import axios from "axios";

import {
  FETCH_CLASSRECORDS,
  FETCH_CLASSRECORD,
  SUBMIT_CLASSRECORD,
  LOADING_CLASSRECORDS,
  DELETE_CLASSRECORD
} from "./type";

// Submit class record (when unit is completed)
export const submitClassRecord =
  (classRecordData, callback) => async (dispatch, getStore) => {
    try {
      const response = await axios.post("class-records", classRecordData);

      const { classRecord } = response.data;

      dispatch({
        type: SUBMIT_CLASSRECORD,
        payload: { classRecord }
      });

      if (callback) callback(classRecord);
    } catch (error) {
      console.error("Error submitting class record:", error);
      throw error;
    }
  };

// Fetch all class records with filtering and pagination
export const fetchClassRecords =
  (options = {}, callback) =>
  async (dispatch, getStore) => {
    dispatch({ type: LOADING_CLASSRECORDS, payload: true });

    const {
      name,
      school,
      class: className,
      booksetId,
      booktypeId,
      bookId,
      unitId,
      startDate,
      endDate,
      userId,
      page,
      limit,
      sortBy,
      sortOrder
    } = options;

    // Build query parameters
    const queryParams = new URLSearchParams();

    if (name) queryParams.append("name", name);
    if (school) queryParams.append("school", school);
    if (className) queryParams.append("class", className);
    if (booksetId) queryParams.append("booksetId", booksetId);
    if (booktypeId) queryParams.append("booktypeId", booktypeId);
    if (bookId) queryParams.append("bookId", bookId);
    if (unitId) queryParams.append("unitId", unitId);
    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (userId) queryParams.append("userId", userId);
    if (page) queryParams.append("page", page);
    if (limit) queryParams.append("limit", limit);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);

    const query = queryParams.toString() ? `?${queryParams.toString()}` : "";

    try {
      const response = await axios.get(`class-records${query}`);

      const { classRecords, pagination } = response.data;

      dispatch({
        type: FETCH_CLASSRECORDS,
        payload: { classRecords, pagination }
      });

      dispatch({ type: LOADING_CLASSRECORDS, payload: false });

      if (callback) callback(response.data);
    } catch (error) {
      console.error("Error fetching class records:", error);
      dispatch({ type: LOADING_CLASSRECORDS, payload: false });
    }
  };

// Fetch a single class record by ID
export const fetchClassRecord =
  (classRecordId, callback) => async (dispatch, getStore) => {
    try {
      const response = await axios.get(`class-records/${classRecordId}`);

      const { classRecord } = response.data;

      if (!classRecord) {
        console.error("No classRecord in response:", response.data);
        throw new Error("No class record data in response");
      }

      dispatch({
        type: FETCH_CLASSRECORD,
        payload: { classRecord }
      });

      if (callback) callback(classRecord);
    } catch (error) {
      console.error("Error fetching class record:", error);
      throw error;
    }
  };

// Delete a class record by ID
export const deleteClassRecord =
  (classRecordId, callback) => async (dispatch, getStore) => {
    try {
      await axios.delete(`class-records/${classRecordId}`);

      dispatch({
        type: DELETE_CLASSRECORD,
        payload: { classRecordId }
      });

      if (callback) callback();
    } catch (error) {
      console.error("Error deleting class record:", error);
      throw error;
    }
  };
